module.exports = "/lucky-balls/img/jackpot/010.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/jackpot/010.png
// module id = 1110
// module chunks = 0